import { useMutation } from "@apollo/client";
import { parseError } from "apollo";
import Button from "components/base/Button";
import { Alert } from "components/base/Toast";
import { BsTrash } from "react-icons/bs";
import {
  DELETE_PROJECT_TASK,
  SAVE_PROJECT_TASK,
  TOGGLE_PROJECT_TASK,
} from "./graphql";

const TaskView = ({ task }) => {
  const [save, saveRes] = useMutation(SAVE_PROJECT_TASK, {
    onError(error) {
      Alert("error", parseError(error));
    },
  });
  const [toggle, toggleRes] = useMutation(TOGGLE_PROJECT_TASK, {
    onError(error) {
      Alert("error", parseError(error));
    },
  });
  const [deleteTask, deleteTaskRes] = useMutation(DELETE_PROJECT_TASK, {
    onError(error) {
      Alert("error", parseError(error));
    },
  });

  function toggleCompleted() {
    toggle({
      variables: { id: task.id },
      optimisticResponse: {
        saveProjectTask: {
          id: task.id,
          completedAt:
            task.completedAt === null ? new Date().toISOString() : null,
          __typename: "ProjectTaskType",
        },
      },
    });
  }

  function deleteTaskHandler() {
    if (window.confirm("Are you sure you want to delete this task?")) {
      deleteTask({ variables: { id: task.id } });
    }
  }

  function editTaskHandler() {
    const name = window.prompt("Update task:", task.name);
    if (name) {
      save({ variables: { id: task.id, name } });
    }
  }

  return (
    <div className="flex justify-between items-center space-x-4">
      <div className="flex items-center space-x-2 flex-1">
        <input
          id={`project-task-${task.id}`}
          disabled={toggleRes.loading}
          type="checkbox"
          checked={task.completedAt !== null}
          onChange={toggleCompleted}
        />
        <label
          htmlFor={`project-task-${task.id}`}
          className="flex-1 hover:text-blue-600 whitespace-normal"
        >
          {task.name}
        </label>
      </div>

      <div className="opacity-70 flex space-x-1">
        <Button
          edit
          onClick={editTaskHandler}
          loading={saveRes.loading}
        ></Button>
        <Button
          onClick={deleteTaskHandler}
          danger
          loading={deleteTaskRes.loading}
        >
          <BsTrash />
        </Button>
      </div>
    </div>
  );
};

export default TaskView;
